import { useCallback, useEffect, useRef, useState } from 'react'
import { adminPassportApi as api } from '../../../Api/passport'
export const message = error => error.response?.data?.message || error.message || 'Не вдалося виконати запит. Спробуйте ще раз.'
export function useAdminResource(path) {
    const [data, setData] = useState(null), [loading, setLoading] = useState(false), [error, setError] = useState(''), [revision, setRevision] = useState(0)
    const reload = useCallback(() => setRevision(value => value + 1), [])
    useEffect(() => {
        let active = true
        setData(null); setError('')
        if (!path) { setLoading(false); return () => { active = false } }
        setLoading(true)
        api.get(path).then(value => { if (active) setData(value) }).catch(error => { if (active) setError(message(error)) }).finally(() => { if (active) setLoading(false) })
        return () => { active = false }
    }, [path, revision])
    return { data, loading, error, reload }
}
export function useAdminAction() {
    const lock = useRef(false), mounted = useRef(true)
    const [busy, setBusy] = useState(false), [error, setError] = useState(''), [notice, setNotice] = useState('')
    useEffect(() => { mounted.current = true; return () => { mounted.current = false } }, [])
    async function run(action) {
        if (lock.current) return false
        lock.current = true; setBusy(true); setError(''); setNotice('')
        try { await action(); return true } catch (error) { if (mounted.current) setError(message(error)); return false }
        finally { lock.current = false; if (mounted.current) setBusy(false) }
    }
    return { busy, error, notice, setNotice, run }
}
export function numeric(value, min, max, label) {
    const number = Number(value)
    if (String(value).trim() === '' || !Number.isSafeInteger(number) || number < min || number > max) throw new Error(`${label}: ціле число від ${min} до ${max}`)
    return number
}
